// extracted by mini-css-extract-plugin
export var displayNone = "_ud-6";
export var imgContainer = "_ud-2";
export var overflowHidden = "_ud-3";
export var productInfoCardButtonContainer = "_ud-5";
export var productTitleText = "_ud-4";
export var rightArrow = "_ud-1";
export var rightArrowContainer = "_ud-0";